import {
  AGENDA_MODEL_LIST_REQUEST,
  AGENDA_MODEL_LIST_SUCCESS,
  AGENDA_MODEL_LIST_FAILURE,
  AGENDA_MODEL_CREATE_REQUEST,
  AGENDA_MODEL_CREATE_SUCCESS,
  AGENDA_MODEL_CREATE_FAILURE,
  AGENDA_MODEL_UPDATE_REQUEST,
  AGENDA_MODEL_UPDATE_SUCCESS,
  AGENDA_MODEL_UPDATE_FAILURE,
  AGENDA_MODEL_DELETE_REQUEST,
  AGENDA_MODEL_DELETE_SUCCESS,
  AGENDA_MODEL_DELETE_FAILURE
} from "@store/actions/settings/_agendaModelAction";

import { combineObjectWithoutCloning } from "@helpers/_functions";

const initialState = {
  isLoaded: false,
  list: [],
  loading: false,
  error: null,
  current: null
};

export const agendaModelReducer = {
  initialState,
  handlers: {
    // LIST
    [AGENDA_MODEL_LIST_REQUEST]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: true, error: null }),
    [AGENDA_MODEL_LIST_SUCCESS]: (state, payload) =>
      combineObjectWithoutCloning(state, {
        isLoaded: true,
        loading: false,
        list: payload,
        error: null
      }),
    [AGENDA_MODEL_LIST_FAILURE]: (state, payload) =>
      combineObjectWithoutCloning(state, {
        isLoaded: true,
        loading: false,
        error: payload
      }),

    // CREATE
    [AGENDA_MODEL_CREATE_REQUEST]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: true, error: null }),
    [AGENDA_MODEL_CREATE_SUCCESS]: (state, payload) =>
      combineObjectWithoutCloning(state, {
        loading: false,
        list: [payload, ...state.list]
      }),
    [AGENDA_MODEL_CREATE_FAILURE]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: false, error: payload }),

    // UPDATE
    [AGENDA_MODEL_UPDATE_REQUEST]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: true, error: null }),
    [AGENDA_MODEL_UPDATE_SUCCESS]: (state, payload) =>
      combineObjectWithoutCloning(state, {
        loading: false,
        list: state.list.map((item) =>
          item._id === payload._id ? payload : item
        )
      }),
    [AGENDA_MODEL_UPDATE_FAILURE]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: false, error: payload }),

    // DELETE
    [AGENDA_MODEL_DELETE_REQUEST]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: true, error: null }),
    [AGENDA_MODEL_DELETE_SUCCESS]: (state, payload) =>
      combineObjectWithoutCloning(state, {
        loading: false,
        list: state.list.filter((item) => item._id !== payload)
      }),
    [AGENDA_MODEL_DELETE_FAILURE]: (state, payload) =>
      combineObjectWithoutCloning(state, { loading: false, error: payload }),
    RESET_ALL: () => initialState //RESET_ALL for all redux reducers
  }
};

export default agendaModelReducer;
